import { render } from "./ControlCenter.vue?vue&type=template&id=3671ef80"
import script from "./ControlCenter.vue?vue&type=script&lang=js"
export * from "./ControlCenter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__